var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupo859(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.029,
    height: 142.029,
    viewBox: "0 0 142.029 142.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_215",
    x: 0,
    y: 0,
    width: 142.029,
    height: 142.029,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_216",
    x: 12.685,
    y: 12.685,
    width: 116.659,
    height: 116.659,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_859",
    "data-name": "Grupo 859",
    transform: "translate(-715.342 -3006.226)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 715.34, 3006.23)",
    filter: "url(#Elipse_215)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_215-2",
    "data-name": "Elipse 215",
    cx: 66.763,
    cy: 66.763,
    r: 66.763,
    transform: "translate(1.42 1.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 715.34, 3006.23)",
    filter: "url(#Elipse_216)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_216-2",
    "data-name": "Elipse 216",
    cx: 54.078,
    cy: 54.078,
    r: 54.078,
    transform: "translate(14.1 14.1)",
    fill: "#ffd053"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_741",
    "data-name": "Grupo 741",
    transform: "translate(748.772 3055.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_739",
    "data-name": "Grupo 739"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_822",
    "data-name": "Rect\\xE1ngulo 822",
    width: 5.013,
    height: 22.587,
    transform: "translate(0 3.544) rotate(-44.999)",
    fill: "#616164"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_823",
    "data-name": "Rect\\xE1ngulo 823",
    width: 5.013,
    height: 22.587,
    transform: "translate(15.971 0) rotate(44.999)",
    fill: "#616164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_740",
    "data-name": "Grupo 740",
    transform: "translate(51.483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_824",
    "data-name": "Rect\\xE1ngulo 824",
    width: 5.013,
    height: 22.587,
    transform: "translate(0 3.544) rotate(-44.999)",
    fill: "#616164"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_825",
    "data-name": "Rect\\xE1ngulo 825",
    width: 5.013,
    height: 22.587,
    transform: "translate(15.971) rotate(45)",
    fill: "#616164"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_742",
    "data-name": "Grupo 742",
    transform: "translate(774.378 3076.39)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_217",
    "data-name": "Elipse 217",
    cx: 9.895,
    cy: 16.774,
    rx: 9.895,
    ry: 16.774,
    fill: "#616164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2782",
    "data-name": "Trazado 2782",
    d: "M745.239,3083.624a15.185,15.185,0,0,0-16.5.536c1.785,4.378,4.766,7.249,8.143,7.249C740.4,3091.409,743.483,3088.3,745.239,3083.624Z",
    transform: "translate(-726.993 -3057.861)",
    fill: "#ff6669"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo859);
export default __webpack_public_path__ + "static/media/Grupo 859.d9022d7e2de820c2d83f7e638a2682ab.svg";
export { ForwardRef as ReactComponent };